import React from "react";
import '../styles/Loader.css'
const Loader = () => {
    return (
        <div className="loader-container">
            <div className="loader-pulse"></div>
        </div>
    )
}
export default Loader;